// material-ui
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  return (
    <>
      <Box sx={{ width: '100%', ml: 1 }} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <Box
          component={RouterLink}
          to="/settings"
          aria-label="Open settings"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            textDecoration: 'none',
            borderRadius: 1,
            '&:hover': { opacity: 0.85 }
          }}
        >
          <img src="/CCAI-logo.svg" alt="CCAI Logo" style={{ height: '40px', objectFit: 'contain' }} />
        </Box>
      </Box>
    </>
  );
}
